//#region src/balance_transaction_type.ts
var BalanceTransactionType = /* @__PURE__ */ function(BalanceTransactionType) {
	BalanceTransactionType["Transfer"] = "transfer";
	BalanceTransactionType["TransferReversal"] = "transfer-reversal";
	return BalanceTransactionType;
}(BalanceTransactionType || {});
//#endregion
export { BalanceTransactionType };

//# sourceMappingURL=balance_transaction_type.js.map